import React, { useEffect, useState } from 'react';
import { transform } from 'typescript';
import { globals } from '../../misc/globals';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './TalksQuestionButton.css'

const TalksQuestionButton = (props: UIProperties<TalksQuestionButtonsConfig>) => {

	const [isOver, setIsOver] = useState(false);
	const [isSelected, setIsSelected] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);

    if(props.parameters.onForceHighlight) {
        props.parameters.onForceHighlight((shouldForce: boolean) => {
            setforceHighlight(shouldForce);
        });
    }

	if(!props.parameters.onForceIsSelected) {
        props.parameters.onForceIsSelected = (shouldForce: boolean) => {
            setIsSelected(shouldForce);
        };

		if(props.parameters.onInit) {
			props.parameters.onInit(props.parameters);
		}
    }
    
	useEffect(() => {

	}, [isOver])
	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: '15px',
			width: '438px'
		}}>
			<button tabIndex={props.parameters.isDisabled ? -1 : 0} aria-label={props.parameters.text + '. ' + (isSelected ? 'selected. ' : 'not selected. ')} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all'
            }} onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}}
			onKeyUp={(evt: any) => mapDivEnterToClick(evt, () => {
				isSelected ? (setIsSelected(false)) : (setIsSelected(true));
			})}
			onMouseDown={() => {
				isSelected ? (setIsSelected(false)) : (setIsSelected(true));
			}} onMouseOut={() => {
				setIsOver(false);
			}} 
			aria-disabled={props.parameters.isDisabled}
			onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClickedd) {
					props.parameters.onClickedd();
				}
			}}>
				<img style={{
					pointerEvents: 'none',
					filter: props.parameters.isDisabled ? 'brightness(50%)' : 'brightness(100%)',
				}} src='./assets/images/general/components/questions/radiobutton_small_main.png' />
				{isSelected || props.parameters.shouldLeaveOn ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					zIndex: 2,
					pointerEvents: 'none'
				}} src='./assets/images/general/components/questions/radiobutton_small_down_checked.png' />) : (<div></div>)}
				{isOver || forceHighlight ? (<img style={{
                    position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src='./assets/images/general/components/questions/radiobutton_small_down.png' />) : (<div></div>)}

				<p style={{
					position: 'absolute',
					margin: '15px',
					top: '0',
					left: '50px',
					width: '450px',
					fontSize: '25px',
					color: 'white',
					textAlign: 'left'
				}}>{props.parameters.text}</p>
			</button>
		</div>
	);

};

export interface TalksQuestionButtonsConfig extends BaseConfig{
	srcDisabled?: string;
    isDisabled?: boolean;
	top: string;
	text: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	onClickedd: () => void;
	onInit?: (config: TalksQuestionButtonsConfig) => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
	onForceIsSelected?: (shouldForce: boolean) => void;
}

export default TalksQuestionButton;